// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FsbO","title":"styles_title__sVCeN"};